export default __webpack_public_path__ + "static/117-6c4cf1d759ba4b26975b9676fcbdd795.gif";